export const getUserName = state => state.auth.user.name;
export const getUserEmail = state => state.auth.user.email;
export const getIsAuth = state => state.auth.isAuth;
export const getToken = state => state.auth.token;
export const getIsFetchCurrentUser = state => state.auth.isFetchCurrentUser;

